import React from 'react';

const Text = props => <span {...props} />;

export default Text;



// WEBPACK FOOTER //
// ./src/components/atoms/Text/Text.js